export default "__VITE_ASSET__D5F084kL__"